module.exports = __webpack_public_path__ + "media/images/icons/layers-e20cc17bce06bc036dbfe5dc032a1a10.svg";